import { Alert } from "react-bootstrap";
import ModalCustom from "../../../components/ModalCustom";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useNavigate } from "react-router-dom";


const ModalCambioPrecio = () => {

    const { modals, handlerModal } = useGeneralAppStore();
    const nav = useNavigate()


    return (
        <ModalCustom
            show={modals.includes('descarga_pdf')}
            size={"fullscreen"}
            onHide={() => handlerModal({ modal: false, modalName: "descarga_pdf" })}
            title={() => "Precio"}
        >
            <>
                <div className="d-flex flex-column gap-2">

                    <div className="d-flex flex-column gap-4 pt-3 pb-5">
                        <Alert variant="danger">
                            <h5>El precio de la rifa cambio</h5>
                            <p>Recargue la página para actualizar el precio.</p>
                        </Alert>
                        <button onClick={() => nav('/')} style={{ border: "none", width: "fit-content", backgroundColor: "#FFA000" }} className="mx-auto px-4 fw-bold">RECARGAR</button>
                    </div>

                    {/* <div style={{ width:"80%" }} className=" overflow-hidden mx-auto border border-1 border-secondary   ">
                <img src={solicitud.imgPreview}  className="w-100 h-100 object-fit-contain"></img>
            </div> */}
                </div>
            </>
        </ModalCustom>
    );
}
export default ModalCambioPrecio;